<template>
  <div class="opc-cart__clear" v-if="is">
    <zm-button type="link" ghost aria-label="Remove all" @click="clear">{{ getSelectedPlans.length > 1 ? $t('billing.common.remove_all') : $t('billing.common.remove') }}</zm-button>
  </div>
</template>

<script>
import { planTypes, ABANDON_CART_EMAIL_COOKIE_KEY } from '@/common/constants';
import { mapGetters, mapActions } from 'vuex';
import { isFromMarketingCampaign } from '../coupon/helper/utils';
import { modalHybrid } from '@/utils/modal-utils';
import { mapMutations } from 'vuex';
import { JOINT_SALE_QUERY_PARAM } from '@/views/config/coupon/helper/constant';
import { cancelEmailSchedule } from '@/apis/cart';
export default {
  computed: {
    ...mapGetters(['getSelectedPlans', 'partnerUseInSoftBundle']),
    is(){
      if (modalHybrid.isInWebview) return false;
      if (isFromMarketingCampaign([JOINT_SALE_QUERY_PARAM])) return false;
      // soft bundle case from
      if (window.$config(JOINT_SALE_QUERY_PARAM) && !this.partnerUseInSoftBundle) return false;
      return this.getSelectedPlans.length && (this.$context.is.buyNow || this.$context.is.basic2pro)
    }
  },
  methods: {
    ...mapActions(['removePlanByKey']),
    ...mapMutations(['setDraftPlanFilterKeys', 'resetOpenInvoiceState']),
    async clear() {
      // Cancel scheduled abandon cart emails
      const scID = this.$cookie.get(ABANDON_CART_EMAIL_COOKIE_KEY);
      if (scID) {
        try {
          await Promise.all(scID.split(',').map(item => cancelEmailSchedule(item)));
          this.$cookie.remove(ABANDON_CART_EMAIL_COOKIE_KEY);
        } catch (error) {
          console.error('Error canceling email schedule:', error);
        }
      }

      this.getSelectedPlans.forEach((x) => {
        let key = planTypes.map([x.type])?.[0] ?? '';
        if (!key) return;
        this.removePlanByKey({
            key,
            force: true
        });
      });

      this.setDraftPlanFilterKeys([]); // there are invalidated plan cards

      this.resetOpenInvoiceState();

      this.$tracking.persistentCart('cart empty state - remove all');
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-cart__clear {
  text-align: center;
  padding-top: 16px;
}
</style>
